module.exports = __webpack_public_path__ + "static/media/mifacturaperu.bd1046e6.png";